<template>
  <div class="con-wrap">
    <p class="box-title">轨迹查询</p>
    <div class="map-wrap">
      <div class="query-box">
        <el-form ref="queryForm" :model="queryForm" size="mini" :inline="true">
          <el-form-item prop="time">
            <el-row>
              <el-col :span="10">
                <el-date-picker v-model="queryDate" :clearable="false" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期" :picker-options="expireTimeOption" @focus="isShow()">
                </el-date-picker>
              </el-col>
              <el-col :span="14">
                <el-time-picker is-range :clearable="false" v-model="oneTimeDay" format="HH:mm:ss"
                  value-format="HH:mm:ss" range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间"
                  placeholder="选择时间范围">
                </el-time-picker>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <el-button type="primary" @click="query">查询</el-button>
      </div>
      <div class="dayMessage" v-if="day">
        <p>轨迹里程：{{ infoWindowData.distance / 1000 || "-" }}公里</p>
        <p>发电时长：{{ infoWindowData.dynamoTime || dynamoTime || "-" }}</p>
      </div>
      <div id="map-box" v-loading="loading" element-loading-text="拼命加载中"></div>
    </div>
    <div class="trackList" ref="rTextareaWrap">
      <el-button class="resize-line" @mousedown.native="handleMouseDown" v-show="openClose"></el-button>
      <div v-if="openClose" style="margin: 0 0 0 20px;">
        <el-button type="text" @click="checkSelectTrack">查看轨迹</el-button>
      </div>
      <el-tabs v-model="pointActiveName">
        <el-tab-pane label="点位事件列表" name="point">
          <el-table v-show="openClose" :data="pointTableData" @selection-change="handleSelectionChange"
            :height="openClose ? nowTable - 50 : 32" border style="width: 100%">
            <el-table-column type="selection" width="25"> </el-table-column>
            <el-table-column prop="serialNumber" label="序号" align="center" min-width="50">
              <template slot-scope="{ row }">
                {{ judge(row) }}
              </template>
            </el-table-column>
            <el-table-column prop="startTime" min-width="160" label="停车时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="endTime" min-width="160" label="启动时间"></el-table-column>
            <el-table-column prop="parkTrackInfos[0].idlingTime" min-width="100" label="怠速时长"></el-table-column>
            <el-table-column prop="parkTrackInfos[0].stopInterval" min-width="100" label="停车时长"></el-table-column>
            <!-- <el-table-column
              prop="mileage"
              min-width="140"
              label="距离上个点的里程"
            >
              <template slot-scope="scope">
                {{ scope.row.mileage }}公里
              </template>
            </el-table-column> -->
            <el-table-column prop="addr" min-width="300" label="位置" show-overflow-tooltip></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="分段轨迹列表" name="track">
          <el-table v-show="openClose" :data="tableData" @selection-change="handleSelectionChange"
            :height="openClose ? nowTable - 50 : 32" border style="width: 100%">
            <el-table-column type="selection" width="25"> </el-table-column>
            <el-table-column type="index" label="序号" align="center" width="50">
            </el-table-column>
            <el-table-column prop="startTime" width="150" label="开始时间">
            </el-table-column>
            <el-table-column prop="startAddr" width="210" show-overflow-tooltip label="开始地点">
            </el-table-column>
            <el-table-column prop="endTime" width="150" label="结束时间">
            </el-table-column>
            <el-table-column prop="endAddr" width="210" show-overflow-tooltip label="结束地点">
            </el-table-column>
            <el-table-column prop="mileage" label="轨迹里程">
              <template slot-scope="scope">
                {{ scope.row.mileage }}公里
              </template>
            </el-table-column>
            <el-table-column prop="duration" label="轨迹时长" min-width="120px">
            </el-table-column>
            <el-table-column prop="interval" width="150" label="与上一段轨迹间隔时间">
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="openClose" @click="openCloseBtn" style="cursor: pointer">
        <el-button type="text danger" style="color: red">轨迹详情</el-button>
        <!-- <i class="iconfont" style="color:#0094FF" :class="openClose?'iconxia':'iconweibiaoti33'"></i> -->
        <i class="iconfont" style="color: red" :class="openClose ? 'iconxia' : 'iconweibiaoti33'"></i>
      </div>
    </div>

    <!-- 高德地图点击车辆标注显示的盒子 -->
    <el-row class="infoWindow" ref="pankInfowindow" v-show="pankShow">
      <i class="delta"></i>
      <div>
        <div>
          <span>位置：</span>
          <span>{{ pankInfowindowData.addr }}</span>
        </div>
        <div class="infoWindowTab" v-if="tabTitle.length > 1">
          <el-tabs v-model="activeName">
            <el-tab-pane v-for="item of tabTitle" :label="item.name" :key="item.id" :name="item.id">
              <div v-if="item.id == 'pank'">
                <div v-for="(item, index) of pankList" :key="index + 1">
                  <p>停车开始时间：{{ item.stopTime }}</p>
                  <p>停车结束时间：{{ item.parkingEndTime }}</p>
                  <p>停车时长：{{ item.stopInterval }}</p>
                  <p>怠速时长：{{ item.idlingTime }}</p>
                </div>
              </div>
              <div v-if="item.id == 'power'">
                <div v-for="(item, index) of powerList" :key="index + 1">
                  <p v-if="item.error == 2" style="color: #f00; font-weight: bolder">
                    违规发电
                  </p>
                  <p>发电开始时间：{{ item.stopTime }}</p>
                  <p>发电时长：{{ item.dynamoTime }}</p>
                </div>
              </div>
              <div v-if="item.id == 'oil'">
                <div v-for="(item, index) of oilList" :key="index + 1">
                  <p v-if="item.error == 2" style="color: #f00; font-weight: bolder">
                    违规加油
                  </p>
                  <p>加油开始时间：{{ item.stopTime }}</p>
                  <p>加油量：{{ item.oilDiff }}升</p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-else>
          <template v-if="justOne">
            <p v-if="pankInfowindowDataOne.error == 2" style="color: #f00; font-weight: bolder">
              {{ pankInfowindowDataOne.type == 2 ? "违规发电" : "违规加油" }}
            </p>
            <p v-if="pankInfowindowDataOne.type != 1">
              <span>{{
                pankInfowindowDataOne.type == 2 ? "发电" : "加油"
              }}开始时间：<span>{{
                  pankInfowindowDataOne.stopTime
                }}</span></span>
            </p>
            <p v-if="pankInfowindowDataOne.type == 1">
              <span>停车开始时间：<span>{{
                pankInfowindowDataOne.stopTime
              }}</span></span>
              <span>停车结束时间：<span>{{
                pankInfowindowDataOne.parkingEndTime
              }}</span></span>
            </p>
            <p v-if="pankInfowindowDataOne.type != 3">
              <span v-if="pankInfowindowDataOne.type == 1">停车时长：<span>{{
                pankInfowindowDataOne.stopInterval
              }}</span></span>
              <span v-if="pankInfowindowDataOne.type == 2">发电时长：<span>{{
                pankInfowindowDataOne.dynamoTime
              }}</span></span>
            </p>
            <p v-if="pankInfowindowDataOne.type == 1">
              <span>怠速时长：<span>{{
                pankInfowindowDataOne.idlingTime
              }}</span></span>
            </p>
            <p v-if="pankInfowindowDataOne.type == 3">
              <span>加油量：<span>{{ pankInfowindowDataOne.oilDiff }}升</span></span>
            </p>
          </template>
          <template v-else>
            <div v-if="parkType == '1'">
              <div v-for="(item, index) of pankList" :key="index + 1">
                <p>停车开始时间：{{ item.stopTime }}</p>
                <p>停车结束时间：{{ item.parkingEndTime }}</p>
                <p>停车时长：{{ item.stopInterval }}</p>
                <p>怠速时长：{{ item.idlingTime }}</p>
              </div>
              <div v-if="parkType == '2'">
                <div v-for="(item, index) of powerList" :key="index + 1">
                  <p v-if="item.error == 2" style="color: #f00; font-weight: bolder">
                    违规发电
                  </p>
                  <p>发电开始时间：{{ item.stopTime }}</p>
                  <p>发电时长：{{ item.dynamoTime }}</p>
                </div>
              </div>
              <div v-if="parkType == '3'">
                <div v-for="(item, index) of oilList" :key="index + 1">
                  <p v-if="item.error == 2" style="color: #f00; font-weight: bolder">
                    违规加油
                  </p>
                  <p>加油开始时间：{{ item.stopTime }}</p>
                  <p>加油量：{{ item.oilDiff }}升</p>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import AMap from "AMap";
const TextAreaWrap = {
  MaxHeight: 600,
  MinHeight: 226,
};
export default {
  name: "TrackQuery",
  props: {
    vin: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pointTableData: [],
      mileage: 0,
      selectStart: null,
      selectEnd: null,
      day: false,
      activeName: "pank",
      pointActiveName: "point",
      pankShow: false,
      queryDate: null,
      oneTimeDayStart: "00:00:00",
      oneTimeDayEnd: "23:59:59",
      tableData: [],
      switch: true,
      endSwitch: true,
      startSwitch: true,
      queryForm: {
        startTime: "",
        endTime: "",
      },
      drivingStatus: "",
      unabled: null,
      selectVal: false,
      disabled: false,
      openClose: false,
      // openCloseTitle:'打开',
      map: null,
      marker: null,
      endMarker: null,
      startMarker: null,
      geocoder: null,
      pointInfoWindow: null,
      infoWindowData: {},
      dynamoTime: null,
      locationData: [],
      pankData: [],
      powerData: [],
      refuelData: [],
      startPoint: [],
      endPoint: [],
      pankMarker: [],
      pankInfowindow: null,
      pankInfowindowData: {},
      pankInfowindowDataOne: {},
      justOne: false,
      parkType: null,
      tabTitle: [],
      pankList: [],
      powerList: [],
      oilList: [],
      pkMarker: null,
      panktSwitch: true,
      oilStateMarker: null,
      powerStateMarker: null,
      polyline: null,
      passedPolyline: null,
      scale: null,
      loading: false,
      nowTable: 230,
      timeDay: "",
      hasBadgeData: [],
      expireTimeOption: {
        disabledDate(date) {
          // 当天可选：date.getTime() < Date.now() - 24 * 60 * 60 * 1000
          return date.getTime() > Date.now();
        },
        cellClassName: (date) => {
          const month = date.getMonth() + 1;
          const day = date.getDate();
          const val =
            date.getFullYear() +
            "-" +
            (month < 10 ? "0" + month : month) +
            "-" +
            (day < 10 ? "0" + day : day);
          if (
            this.hasBadgeData.length > 0 &&
            this.hasBadgeData.indexOf(val) >= 0
          ) {
            return "badge"; //有系统读数的日期显示红色标记
          } else {
            return ""; //没有系统读数的日期不显示红色标记
          }
        },
      },
      idAndIndexArr: [],
      handleArr: [],
      flagStart: false,
      flagEnd: false,
      flag: false,
      node: document.querySelectorAll(".el-picker-panel"),
    };
  },
  computed: {
    oneTimeDay: {
      get() {
        return [
          new Date(this.queryDate + " " + this.oneTimeDayStart),
          new Date(this.queryDate + " " + this.oneTimeDayEnd),
        ];
      },
      set(value) {
        this.oneTimeDayStart = value[0];
        this.oneTimeDayEnd = value[1];
      },
    },
  },
  mounted() {
    this.init();
    this.query();
  },
  methods: {
    judge(row) {
      if (row.serialNumber == 0) {
        return "起";
      } else if (
        row.serialNumber == this.pointTableData.length - 1 &&
        row.driving == 0
      ) {
        return "终";
      } else {
        return row.serialNumber;
      }
    },
    // 获取焦点 展示日期
    isShow() {
      this.$nextTick(() => {
        let listNode = document.querySelectorAll(
          "[aria-label='下个月'],[aria-label='上个月'],[aria-label='后一年'],[aria-label='前一年']"
        );
        if (listNode && listNode.length > 0) {
          this.monthChange();
          listNode.forEach((item) =>
            item.addEventListener("click", () => {
              this.monthChange();
            })
          );
        }
      });
    },
    // 切换年月后重新调接口
    monthChange() {
      let year, month, newDate;
      // 获取年月
      year = document
        .querySelectorAll(".el-date-picker__header-label")[0]
        .innerHTML.slice(0, 4);
      month = document
        .querySelectorAll(".el-date-picker__header-label")[1]
        .innerHTML.slice(0, -1);
      if (Number(month) < 10) {
        // 10月之前都需要补0
        month = "0" + month;
      }
      newDate = year + "-" + month;
      let { year: currentYear, month: currentMonth } = this.getCurrentDate();
      // 只查取到当前日期
      if (year < currentYear) {
        this.getBadgeData(newDate);
      } else if (year == currentYear) {
        if (month <= currentMonth) {
          this.getBadgeData(newDate);
        }
      }
    },
    async getBadgeData(newDate) {
      let obj = {};
      obj.vin = this.vin;
      obj.timeDay = newDate;
      let { data: res } = await this.$axios.get(
        "/api/vehicle/details/track/monthly",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        this.hasBadgeData = res.data;
      }
    },
    getCurrentDate() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // JavaScript的月份是从0开始的，所以需要加1
      // const day = date.getDate();
      return { year, month };
    },
    handleSelectionChange(val) {
      // 将选中点排序，无论用户先选择哪一个数据，都按显示表格顺序排序
      val.sort((a, b) => {
        return a.id - b.id;
      });
      let l = val.length;
      let j =
        this.pointActiveName == "point"
          ? this.pointTableData.length
          : this.tableData.length;
      // 接口参数的开始时间
      let startTime = "";
      // 接口参数的结束时间
      let endTime = "";
      let prevStart = "";
      let nextStart = "";
      let target = "";
      // 记录轨迹里程
      this.mileage = 0;
      // 用户选中轨迹数据
      if (val && l > 0) {
        this.selectVal = true;
        for (let i = 0; i < l; i++) {
          this.mileage = this.mileage + val[i].mileage;
          // 选中表格第一个数据时开始时间设置为当天的"00:00:00"
          if (val[0].serialNumber == 1 || val[0].serialNumber == 0) {
            // 选中1的时候轨迹开始时间是起点时间
            // 选中1的时候默认显示起点
            this.flagStart = true;
            startTime = val[i].startTime
              ? val[i].startTime.split(" ")[0] + " " + "00:00:00"
              : val[i].endTime.split(" ")[0] + " " + "00:00:00";
            if (this.pointActiveName == "point") {
              target = this.pointTableData.filter(
                (item) => item.id == val[l - 1].id
              );
              nextStart = this.pointTableData[target[0].serialNumber + 1]
                .startTime;
            } else {
              target = this.tableData.filter(
                (item) => item.id == val[l - 1].id
              );
              nextStart = this.tableData[target[0].serialNumber].startTime;
            }
          } else {
            // 没有选中表格第一个数据时  ，每一次选中提交两个time【后一个开始时间和前一个开始时间】
            // 因为每一次点击会push两个time，所以会出现小的time在后面的情况
            if (this.pointActiveName == "point") {
              prevStart = "";
              nextStart = "";
              if (j == val[i].serialNumber + 1 && l != 1) {
                // 选中终点数据了
                console.log("选中终点数据了");
                prevStart = this.pointTableData[val[0].serialNumber - 2]
                  ? this.pointTableData[val[0].serialNumber - 2].startTime
                  : "";
              } else {
                prevStart = this.pointTableData[val[0].serialNumber - 1]
                  ? this.pointTableData[val[0].serialNumber - 1].startTime
                  : "";
              }
              nextStart = this.pointTableData[val[l - 1].serialNumber + 1]
                ? this.pointTableData[val[l - 1].serialNumber + 1].startTime
                : "";
            } else {
              prevStart = "";
              nextStart = "";
              prevStart = this.tableData[val[0].serialNumber - 2]
                ? this.tableData[val[0].serialNumber - 2].startTime
                : "";
              nextStart = this.tableData[val[l - 1].serialNumber]
                ? this.tableData[val[l - 1].serialNumber].startTime
                : "";
            }
            this.flagStart = false;
            // 没有选1时，轨迹开始时间是选中数据前一个的时间
            startTime = prevStart;
          }
          // 轨迹结束时间【选择最晚的时间即可】
          let endTableDataId =
            this.pointActiveName == "point"
              ? this.pointTableData[j - 1].id
              : this.tableData[j - 1].id;
          // 未选中最后一个数据 结束时间取下一个数据的开始时间
          this.flagEnd = false;
          endTime = nextStart;
          if (val[l - 1].id == endTableDataId) {
            // 选中最后一个数据
            console.log("选中最后一个数据");
            this.flagEnd = true;
            endTime = val[l - 1].startTime.split(" ")[0] + " " + "23:59:59";
          }
          this.selectStart = startTime;
          this.selectEnd = endTime;
        }
      } else {
        this.selectStart = "";
        this.selectEnd = "";
        this.selectVal = false;
      }
    },
    // 查看轨迹
    checkSelectTrack() {
      this.flag = false;
      if (!this.selectVal) {
        this.$message.warning("请至少选择一条轨迹查看");
        return;
      } else {
        let obj = {
          vin: this.vin,
          startTime: this.selectStart,
          endTime: this.selectEnd,
        };
        this.getTrack(obj, true).then(() => {
          this.infoWindowData.distance = this.mileage * 1000;
        });
        this.getPankData(obj);
        this.flag = true;

        // // 选1显示起点，不选1隐藏起点
        // if (!this.flagStart) {
        //   if (this.startMarker) {
        //     this.startMarker = null;
        //     this.map.remove(this.startMarker);
        //   }
        // }
        // // 选最后一个点才显示终点【因为选最后一个点时结束时间是终点的时间】
        // if (!this.flagEnd) {
        //   if (this.endMarker) {
        //     this.endMarker = null;
        //     this.map.remove(this.endMarker);
        //   }
        // }
      }
    },
    openCloseBtn() {
      this.openClose = !this.openClose;
      this.changeH();
      // this.openCloseTitle=this.openClose?'收起':'打开'
    },
    changeH() {
      let H = this.openClose ? this.nowTable : 32;
      this.$refs.rTextareaWrap.style.height = H + "px";
    },
    init() {
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 10,
        // mapStyle: "amap://styles/grey",
      });
      AMap.plugin(["AMap.Geocoder"], () => {
        this.geocoder = new AMap.Geocoder({
          city: "全国", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        });
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        this.scale = new AMap.Scale({
          visible: true,
        });
        this.map.addControl(this.scale);
      });
    },
    // 查询轨迹列表页
    async getTrackList(timeDay) {
      let _this = this;
      let time = timeDay ? timeDay : _this.timeDay;
      let obj = {
        vin: _this.vin,
        timeDay: time,
        pageNum: 1,
        pageSize: 10000,
        startStr: _this.oneTimeDayStart,
        endStr: _this.oneTimeDayEnd,
      };
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/gps/driving",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.tableData = res.data.list;
        // 标记轨迹列表数据的序号【用于记录画轨迹时的标记点数字】
        _this.tableData.forEach((item, index) => {
          item.serialNumber = index + 1;
        });
      }
    },
    // 查询定位
    async vehicleLocation() {
      // 确保 geocoder 已初始化
      if (!this.geocoder) {
        console.error("Geocoder 未初始化，请检查插件加载");
        return;
      }
      let _this = this;
      let vin = _this.vin;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/location?vin=" + vin
      );
      if (res.code == 1) {
        //清理覆盖物
        if (_this.marker) {
          _this.map.remove(_this.marker);
        }
        _this.marker = new AMap.Marker({
          position: [res.data.longitude, res.data.latitude],
        });
        // var mkIcon = new AMap.Icon({
        //   // 图标尺寸
        //   size: new AMap.Size(40, 24),
        //   // 图标的取图地址
        //   image: require("@/assets/images/checked.gif"),
        //   // 图标所用图片大小
        //   imageSize: new AMap.Size(40, 24),
        //   // 图标取图偏移量
        //   // imageOffset: new AMap.Pixel(-9, -3)
        // })
        // let mk = new AMap.Marker({
        //   position: [res.data.longitude,res.data.latitude],
        //   icon: mkIcon,
        //   // size: new AMap.Size(46, 24),
        //   offset: new AMap.Pixel(-22,-10),
        // })
        _this.map.setCenter([res.data.longitude, res.data.latitude]);
        // _this.map.add(mk)
        _this.map.add(_this.marker);
        _this.marker.on("click", function () {
          _this.geocoder.getAddress(
            [res.data.longitude, res.data.latitude],
            function (status, result) {
              if (status === "complete" && result.info === "OK") {
                var address = result.regeocode.formattedAddress;
                var info = [];
                info.push(
                  "<p class='input-item'>当前位置：" + address + "</p>"
                );
                _this.pointInfoWindow = new AMap.InfoWindow({
                  offset: new AMap.Pixel(0, -38),
                  anchor: "bottom-center",
                  closeWhenClickMap: true,
                  autoMove: true,
                  content: info.join(""), //使用默认信息窗体框样式，显示信息内容
                });
                if (_this.switch) {
                  _this.pointInfoWindow.open(_this.map, [
                    res.data.longitude,
                    res.data.latitude,
                  ]);
                } else {
                  _this.pointInfoWindow.close();
                }
                _this.switch = !_this.switch;
              }
            }
          );
        });
      } else {
        _this.$message.warning(res.msg);
      }
    },
    // 查询路线
    async checkTrack(data) {
      this.unabled = data.id;
      let _this = this;
      let obj = {
        vin: _this.vin,
        startTime: data.startTime,
        endTime: data.endTime,
      };
      _this.getTrack(obj, true);
      _this.getPankData(obj);
    },
    // 国际时间转换为标准时间【YYYY-MM-DD HH:mm:ss】
    timestampToTime(timestamp) {
      let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    query() {
      let _this = this;
      _this.timeDay = this.queryDate;
      _this.dynamoTime = null;
      _this.infoWindowData = {};
      _this.parkIds = [];
      _this.getTrackList();
      _this.unabled = null;
      let obj = {};
      if (_this.queryDate) {
        obj.startTime = this.timestampToTime(
          new Date(this.queryDate + " " + this.oneTimeDayStart)
        );
        obj.endTime = this.timestampToTime(
          new Date(this.queryDate + " " + this.oneTimeDayEnd)
        );
      }
      obj.vin = _this.vin;
      _this.loading = true;
      _this.getTrack(obj, true);
      _this.getPankData(obj);
      Promise.all([_this.getTrack(obj, true), _this.getPankData(obj)]).then(
        async () => {
          let { data: res } = await _this.$axios.get(
            "/api/vehicle/details/track/parkV2",
            {
              params: obj,
            }
          );
          if (res.code == 1) {
            _this.pointTableData = res.data;
          } else {
            _this.$message.warning(res.msg);
          }
        }
      );
    },
    // 路线数据
    async getTrack(obj, clear) {
      let _this = this;
      _this.openClose = false;
      _this.changeH();
      _this.startSwitch = true;
      _this.endSwitch = true;
      if (clear) {
        _this.map.clearMap();
      }
      let { data: res } = await _this.$axios.get("/api/vehicle/details/track", {
        params: obj,
      });
      if (res.code == 1) {
        _this.loading = false;
        _this.drivingStatus = res.data.driving;
        if (res.data.counts == 1) {
          //没有路线点，显示车辆定位
          if (res.data.dynamoTime) {
            _this.day = true;
          } else {
            _this.day = false;
          }
          _this.dynamoTime = res.data.dynamoTime;
          _this.vehicleLocation();
          _this.marker = new AMap.Marker({
            position: res.data.endPoint,
          });
          _this.map.setCenter(res.data.endPoint);
          _this.map.add(_this.marker);
          _this.$message.warning(res.msg);
        } else {
          // 有路线点，画轨迹路线
          if (res.data.startTimeAddr && res.data.startTimeAddr.time) {
            // 起始点时间和地址
            _this.queryDate = res.data.startTimeAddr.time.split(" ")[0];
          } else {
            _this.queryDate = "";
          }
          _this.day = true;
          _this.locationData = res.data.points; // GPS点数据
          if (clear) {
            _this.day = true;
            if (res.data.startTimeAddr && res.data.startTimeAddr.time) {
              // 起始点时间和地址
              _this.queryDate = res.data.startTimeAddr.time.split(" ")[0];
            }
            _this.startPoint = res.data.startPoint; //起点
            _this.endPoint = res.data.endPoint; // 终点
            _this.infoWindowData = res.data;
            _this.addMarkers();
            _this.drawingTrack("#0048ff");
          } else {
            if (_this.passedPolyline) {
              _this.map.remove(_this.passedPolyline);
              _this.passedPolyline = null;
            }
            _this.drawingTrack("#00E46B");
          }

          _this.map.setFitView();
        }
      } else {
        _this.loading = false;
        _this.$message.warning(res.msg);
      }
    },
    // 停车点数据
    async getPankData(obj) {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/vehicle/details/track/park",
        {
          params: obj,
        }
      );
      if (res.code == 1) {
        _this.pankData = [];
        _this.pankData = res.data;
        _this.handleArr = res.data;
        // _this.pointTableData = _this.handlePankData(res.data);
        // _this.$nextTick(() => {
        //   if (_this.selectVal) {
        //     _this.handleSelectData(res.data);
        //   }
        //   _this.addPankMarkers();
        // });
        _this.addPankMarkers();
      } else {
        _this.loading = false;
        _this.$message.warning(res.msg);
      }
    },
    // 处理点位事件列表数据
    handlePankData(data) {
      let target = [];
      // 先过滤需要显示的点数据
      data.forEach((item) => {
        target.push({ ...item });
      });
      target.forEach((item) => {
        if (item.parkTrackInfos.length > 0) {
          item.parkTrackInfos = item.parkTrackInfos.filter(
            (item) => item.type == 1
          );
        }
      });
      let newData = [];
      target.forEach((item) => {
        if (item.parkTrackInfos.length > 0) {
          item.parkTrackInfos.forEach((info) => {
            info.addr = item.addr;
          });
        }
        newData.push(item.parkTrackInfos);
      });
      return newData.flat().sort((a, b) => a.serialNumber - b.serialNumber);
    },
    addPankMarkers() {
      let _this = this;
      let number = [];
      if (this.pankMarker.length > 0) {
        this.pankMarker = [];
        this.map.remove(this.pankMarker);
      }
      if (this.handleArr && this.handleArr.length > 0) {
        this.handleArr.forEach((item) => {
          _this.pkMarker = null;
          _this.oilStateMarker = null;
          _this.powerStateMarker = null;
          let isError = false;
          if (item.oilStatus == 2) {
            let oilContent =
              "<img style='width:14px;height:18px'  src='" +
              require("@/assets/images/monitor/icon-fueling.png") +
              "'/>";
            _this.oilStateMarker = new AMap.Marker({
              position: item.lnglat,
              content: oilContent,
              offset: new AMap.Pixel(-25, 8),
              anchor: "bottom-left",
              map: _this.map,
            });
            _this.pankMarker.push(_this.oilStateMarker);
          }
          if (item.dynamoStatus == 2) {
            let powerContent =
              "<img style='width:14px;height:18px'  src='" +
              require("@/assets/images/monitor/icon-powering.png") +
              "'/>";
            _this.powerStateMarker = new AMap.Marker({
              position: item.lnglat,
              content: powerContent,
              offset: new AMap.Pixel(-25, -10),
              anchor: "bottom-left",
              map: _this.map,
            });
            _this.pankMarker.push(_this.powerStateMarker);
          }
          item.parkTrackInfos.map((item) => {
            if (item.error == 2) {
              //有违规
              isError = true;
              return;
            } else {
              isError = false;
            }
          });
          let iconError = new AMap.Icon({
            size: new AMap.Size(20, 30),
            image: require("@/assets/images/error_park.png"),
            imageSize: new AMap.Size(20, 30),
          });
          let iconNormal = new AMap.Icon({
            size: new AMap.Size(20, 30),
            image: require("@/assets/images/park.png"),
            imageSize: new AMap.Size(20, 30),
          });
          let icon = isError ? iconError : iconNormal;
          _this.pkMarker = new AMap.Marker({
            position: item.lnglat,
            icon: icon,
            size: new AMap.Size(20, 36),
            map: _this.map,
            offset: new AMap.Pixel(0, 2),
            anchor: "bottom-center",
          });
          if (item.parkTrackInfos.length > 1) {
            number = [];
            // if (_this.selectVal) {
            //   // 选中数据时序号为 superpositionNum
            //   console.log("重合数据", item.parkTrackInfos);
            //   item.parkTrackInfos.forEach((element) => {
            //     number.push(element.serialNumber);
            //   });
            // } else {
            // 页面初始化时序号为 serialNumber
            item.parkTrackInfos.forEach((element) => {
              if (element.serialNumber) {
                number.push(element.serialNumber);
              }
            });
            // }
          } else {
            // if (_this.selectVal) {
            //   console.log(index);
            //   number = item.serialNumber;
            // } else {
            number = item.serialNumber;
            // }
          }
          _this.pkMarker.setLabel({
            direction: "top-center",
            offset: new AMap.Pixel(0, -26), //设置文本标注偏移量
            content: number ? "<span>" + number + "</span>" : "", //设置文本标注内容
          });
          AMap.event.addListener(_this.pkMarker, "mouseover", (e) => {
            e.target.setTop(true);
          });
          AMap.event.addListener(_this.pkMarker, "mouseout", (e) => {
            e.target.setTop(false);
          });
          // 选中的   显示停车点
          _this.pankMarker.push(_this.pkMarker);
          _this.pkMarker.content = item;
          _this.pkMarker.on("click", function (e) {
            _this.activeName = "pank";
            _this.pankInfowindowData = {};
            _this.pankInfowindowDataOne = {};
            _this.pankInfowindowData = e.target.content;
            let pankLnglat = sessionStorage.getItem("pank");
            _this.pankShow = true;
            if (_this.pankInfowindowData.parkStatus == 2) {
              let obj = {
                vin: _this.vin,
                startTime: _this.pankInfowindowData.parkingQueryStartTime,
                endTime: _this.pankInfowindowData.parkingQueryEndTime,
              };
              _this.getTrack(obj, false);
            }
            // 基站信息窗体
            _this.pankInfowindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: _this.$refs.pankInfowindow.$el,
              offset: new AMap.Pixel(20, -65),
              anchor: "top-left",
              closeWhenClickMap: true,
              autoMove: true,
            });
            if (pankLnglat == e.target.content.lnglat) {
              if (_this.panktSwitch) {
                _this.pankInfowindow.open(_this.map, e.target.content.lnglat);
              } else {
                _this.pankInfowindow.close();
              }
            } else {
              _this.pankInfowindow.open(_this.map, e.target.content.lnglat);
              _this.panktSwitch = true;
            }
            // 对停车点类型进行分类---停车，发电，加油
            if (
              e.target.content.parkTrackInfos &&
              e.target.content.parkTrackInfos.length > 0
            ) {
              _this.tabTitle = [];
              _this.pankList = [];
              _this.powerList = [];
              _this.oilList = [];
              if (
                e.target.content.parkTrackInfos &&
                e.target.content.parkTrackInfos.length == 1
              ) {
                //只一条数据
                _this.pankInfowindowDataOne =
                  e.target.content.parkTrackInfos[0];
                _this.justOne = true;
              } else {
                let arrData = e.target.content.parkTrackInfos;
                _this.justOne = false;
                arrData.forEach((item) => {
                  if (item.type == 1) {
                    //type=1 停车
                    _this.parkType = 1;
                    _this.pankList.push(item);
                  }
                  if (item.type == 2) {
                    //type=2 发电
                    _this.parkType = 2;
                    _this.powerList.push(item);
                  }
                  if (item.type == 3) {
                    //type=3 加油
                    _this.parkType = 3;
                    _this.oilList.push(item);
                  }
                });
                if (_this.pankList.length > 0) {
                  _this.tabTitle.push({
                    id: "pank",
                    name: "停车",
                  });
                }
                if (_this.powerList.length > 0) {
                  _this.tabTitle.push({
                    id: "power",
                    name: "发电",
                  });
                }
                if (_this.oilList.length > 0) {
                  _this.tabTitle.push({
                    id: "oil",
                    name: "加油",
                  });
                }
              }
            }
            _this.panktSwitch = !_this.panktSwitch;
            sessionStorage.setItem("pank", e.target.content.lnglat);
          });
        });
      }
      _this.$nextTick(() => {
        _this.map.add(_this.pankMarker);
      });
    },
    drawingTrack(color) {
      let _this = this;
      if (color == "#0048ff") {
        _this.polyline = new AMap.Polyline({
          map: _this.map,
          path: _this.locationData,
          showDir: true,
          strokeColor: color, //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6, //线宽
          // strokeStyle: "solid"  //线样式
        });
      } else {
        _this.passedPolyline = new AMap.Polyline({
          map: _this.map,
          path: _this.locationData,
          showDir: true,
          strokeColor: color, //线颜色
          // strokeOpacity: 1,     //线透明度
          strokeWeight: 6, //线宽
          // strokeStyle: "solid"  //线样式
        });
      }

      _this.map.setFitView();
    },
    addMarkers() {
      let endIcon = null;
      let _this = this;
      var startIcon = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image:
          "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
        imageSize: new AMap.Size(135, 40),
        imageOffset: new AMap.Pixel(-9, -3),
      });
      var endIconDefault = new AMap.Icon({
        size: new AMap.Size(25, 34),
        image:
          "//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png",
        imageSize: new AMap.Size(135, 40),
        imageOffset: new AMap.Pixel(-95, -3),
      });
      var endIconOne = new AMap.Icon({
        size: new AMap.Size(40, 40),
        image: require("@/assets/images/monitor/car-online-45.png"),
        imageSize: new AMap.Size(24, 40),
        imageOffset: new AMap.Pixel(9, 0),
      });
      var endIconTwo = new AMap.Icon({
        size: new AMap.Size(40, 40),
        image: require("@/assets/images/monitor/car-online-2-45.png"),
        imageSize: new AMap.Size(24, 40),
        imageOffset: new AMap.Pixel(9, 0),
      });
      if (this.drivingStatus == 1) {
        // 车辆还在行驶中，显示车辆图标
        let version = sessionStorage.getItem("version");
        console.log(version);
        if (version == 2) {
          endIcon = endIconTwo;
        } else {
          endIcon = endIconOne;
        }
      } else {
        endIcon = endIconDefault;
      }
      _this.startMarker = new AMap.Marker({
        icon: startIcon,
        anchor: "bottom-center",
        position: _this.startPoint, // 基点位置
        offset: new AMap.Pixel(4, 9), // 设置点标记偏移量
      });
      _this.endMarker = new AMap.Marker({
        icon: endIcon,
        anchor: "bottom-center",
        position: _this.endPoint, // 基点位置
        offset: new AMap.Pixel(-2, 9), // 设置点标记偏移量
      });
      _this.startMarker.on("click", function () {
        _this.endSwitch = true;
        var info = [];
        info.push(
          "<p class='input-item'>时间：" +
          _this.infoWindowData.startTimeAddr.time +
          "</p>" +
          "<p class='input-item'>位置：" +
          _this.infoWindowData.startTimeAddr.addr +
          "</p>"
        );
        _this.pointInfoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -38),
          anchor: "bottom-center",
          closeWhenClickMap: true,
          autoMove: true,
          content: info.join(""), //使用默认信息窗体框样式，显示信息内容
        });
        if (_this.startSwitch) {
          _this.pointInfoWindow.open(_this.map, _this.startPoint);
        } else {
          _this.pointInfoWindow.close();
        }
        _this.startSwitch = !_this.startSwitch;
      });
      _this.endMarker.on("click", function () {
        _this.startSwitch = true;
        var info = [];
        info.push(
          "<p class='input-item'>时间：" +
          _this.infoWindowData.endTimeAddr.time +
          "</p>" +
          "<p class='input-item'>位置：" +
          _this.infoWindowData.endTimeAddr.addr +
          "</p>"
        );
        _this.pointInfoWindow = new AMap.InfoWindow({
          offset: new AMap.Pixel(0, -38),
          anchor: "bottom-center",
          closeWhenClickMap: true,
          autoMove: true,
          content: info.join(""), //使用默认信息窗体框样式，显示信息内容
        });
        if (_this.endSwitch) {
          _this.pointInfoWindow.open(_this.map, _this.endPoint);
        } else {
          _this.pointInfoWindow.close();
        }
        _this.endSwitch = !_this.endSwitch;
      });

      _this.map.add(_this.startMarker);
      _this.map.add(_this.endMarker);
      if (this.flag) {
        //选中显示时
        if (!this.flagStart) {
          _this.map.remove(_this.startMarker);
        }
        if (!this.flagEnd) {
          _this.map.remove(_this.endMarker);
        }
      }
    },
    /**
     * 处理鼠标按下事件
     *
     * @param {MouseEvent} 鼠标事件
     */
    //拖拽功能实现
    handleMouseDown(event) {
      // 禁止用户选择网页中文字
      document.onselectstart = () => false;
      // 禁止用户拖动元素
      document.ondragstart = () => false;

      // 保存鼠标最后移动的位置（Y轴）
      this.dragState = {
        // 鼠标开始移动的位置（Y轴）
        startMouseTop: event.clientY,
        // 鼠标最后移动的位置（Y轴）
        endMouseTop: event.clientY,
      };

      // 绑定鼠标移动事件
      document.addEventListener("mousemove", this.handleMouseMove);
      // 绑定鼠标放开事件
      document.addEventListener("mouseup", this.handleMouseUp);
    },

    /**
     * 处理鼠标移动事件
     *
     * @param {MouseEvent} 鼠标事件
     */
    handleMouseMove(event) {
      const { rTextareaWrap } = this.$refs;
      // 获取鼠标最后移动的位置（Y轴）
      const { endMouseTop } = this.dragState;
      // 获取当前的文本框高度
      const oldTextAreaHeight = rTextareaWrap.getBoundingClientRect().height;
      // 新的文本框高度
      let newTextAreaHeight = 0;

      // 计算鼠标移动的距离
      const distance = Math.abs(
        parseInt(((endMouseTop - event.clientY) * 100).toString(), 10) / 100
      );

      // 若鼠标向上移动
      if (endMouseTop > event.clientY) {
        // 发送框高度达到最大
        if (oldTextAreaHeight >= TextAreaWrap.MaxHeight) {
          // 修改光标为可被向下移动
          //rResizeLine.style.cursor = "s-resize"
          return false;
        }

        // 计算新的发送框高度
        newTextAreaHeight = oldTextAreaHeight + distance;
      }
      // 若鼠标向下移动
      else {
        // 发送框高度达到最小
        if (oldTextAreaHeight <= TextAreaWrap.MinHeight) {
          // 修改光标为可被向上移动
          //rResizeLine.style.cursor = "n-resize"
          return false;
        }

        // 计算新的发送框高度
        newTextAreaHeight = oldTextAreaHeight - distance;
      }

      // 兼容鼠标快速拖动的情况：新的发送框高度不能超过最大值
      if (newTextAreaHeight > TextAreaWrap.MaxHeight) {
        newTextAreaHeight = TextAreaWrap.MaxHeight;
      }

      // 兼容鼠标快速拖动的情况：新的发送框高度不能小于最小值
      if (newTextAreaHeight < TextAreaWrap.MinHeight) {
        newTextAreaHeight = TextAreaWrap.MinHeight;
      }

      // 修改发送框高度
      rTextareaWrap.style.height = newTextAreaHeight + "px";
      this.nowTable = newTextAreaHeight;
      // 修改光标为可移动
      //rResizeLine.style.cursor = "move"

      // 更新鼠标最后移动的位置（Y轴）
      this.dragState.endMouseTop = event.clientY;
    },

    /**
     * 处理鼠标放开事件
     */
    handleMouseUp() {
      // 移除鼠标移动事件
      document.removeEventListener("mousemove", this.handleMouseMove);
      // 移除鼠标放开事件
      document.removeEventListener("mouseup", this.handleMouseUp);
      // 允许用户选择网页中文字
      document.onselectstart = null;
      // 允许用户拖动元素
      document.ondragstart = null;
    },
  },
  beforeDestroy() {
    sessionStorage.removeItem("pank");
  },
};
</script>

<style lang="scss" scoped>
/deep/ .amap-marker-label {
  border-color: #f5850d;
  // background: unset;
  // font-size: 16px;
  // color: #fff;
  // font-weight: bolder;
  padding: 4px;
}

/* 添加样式，使滚动条样式更美观 */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-thumb {
  // border-radius: 10px;
  background-color: #ccc;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #7b7b7b;
}

/* 火狐浏览器滚动条样式 */
/* 滚动条轨道 */
.infoWindow {
  scrollbar-color: #ccc;
  /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
  scrollbar-width: thin;
  /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
  -ms-overflow-style: none;
}

// 高德地图窗体
.infoWindow {
  position: relative;
  padding: 10px;
  background: #fff;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
  line-height: 20px;
  width: 260px;
  border: 1px solid #ccc;
  border-radius: 4px;
  opacity: 0.8;
  max-height: 350px;
  overflow-y: auto;
  // // 三角形
  // .delta{
  //   position:absolute;
  //   left:-10px;
  //   top:30px;
  //   width: 0;
  //   height: 0;
  //   border-top: 8px solid transparent;
  //   border-right: 10px solid #fff;
  //   border-bottom: 8px solid transparent;
  // }

  .infoWindowTab {
    /deep/ .el-tabs__header {
      margin: 0 0 5px;
    }

    /deep/ .el-tabs__item {
      padding: 0;
      padding-right: 10px;
      font-size: 12px;
      height: 25px;
      line-height: 25px;
    }
  }
}

.infoWindow:before {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 30px;
  left: -16px;
  padding: 0;
  border-right: 8px solid #ffffff;
  border-bottom: 8px solid transparent;
  border-left: 8px solid transparent;
  border-top: 8px solid transparent;
  display: block;
  content: "";
  z-index: 12;
}

.infoWindow:after {
  box-sizing: content-box;
  width: 0px;
  height: 0px;
  position: absolute;
  top: 30px;
  left: -19px;
  padding: 0;
  border-right: 9px solid #ccc;
  border-bottom: 9px solid transparent;
  border-left: 9px solid transparent;
  border-top: 9px solid transparent;
  display: block;
  content: "";
  z-index: 10;
}

.con-wrap {
  height: 100%;
  margin: 0;
  background-color: #fff;
  position: relative;
}

.con-wrap .box-title {
  padding-bottom: 10px;
  font-size: 16px;
  font-weight: bold;
  background: #f8f8f8;
}

.map-wrap {
  width: 100%;
  height: calc(100% - 31px);
  position: relative;
}

.query-box {
  width: 730px;
  height: 72px;
  position: absolute;
  top: 20px;
  left: 20px;
  padding: 20px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  z-index: 2;
}

.dayMessage {
  width: 220px;
  height: 72px;
  position: absolute;
  top: 20px;
  left: 770px;
  padding: 10px;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.8);
  box-sizing: border-box;
  z-index: 2;
  color: #fff;

  p {
    line-height: 25px;
    font-size: 14px;
  }
}

.query-box form {
  margin-right: 28px;
  float: left;
}

.query-box btn {
  float: left;
}

#map-box {
  width: 100%;
  height: 100%;
  border: 1px solid #cbcbcb;
  box-sizing: border-box;
}

/deep/ .amap-info-content {
  .amap-info-close {
    display: none;
  }

  .input-item {
    line-height: 25px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}

.trackList {
  position: absolute;
  width: 97%;
  background: #fff;
  border-radius: 6px;
  bottom: 28px;
  left: 50%;
  transform: translate(-50%, -8%);
  z-index: 120;

  .openClose {
    position: absolute;
    background: #f4f4f4;
    padding: 0 9px;
    top: -33px;
    width: 75px;
    right: 0px;
    height: 33px;
    line-height: 33px;
  }

  /deep/ .el-tabs__nav-wrap {
    background: #fff;
    padding: 0 20px;
  }
}

/deep/ .el-table {
  td {
    padding: 4px 0px;
  }

  th {
    padding: 4px 0px;
  }
}

//可拖拽
.resize-line {
  width: 100%;
  height: 5px;
  background-color: #0094ff;
  cursor: row-resize;
}

::v-deep .amap-scalecontrol {
  left: auto !important;
  right: 2px;
  top: 20px;
  bottom: auto !important;
  z-index: 1;
}

::v-deep .el-range-editor--mini .el-range-input {
  font-size: 14px;
}
</style>
